
const registerDefault = {
  allow_reset: false,
  delete_history: 0,
  factory_reset: 0,
  body_fat: '',
  calorie_restricted: 0,
  bfCalculatedType: '',
  confirm_email_address: '',
  activity_level_life: '0',
  activity_level_exercise: '0',
  experience_level: 'BEGINNER',
  fat_content: 3,
  fat_permyriad: 3000,
  full_name: '',
  gender: '',
  goal: 'FAT LOSS',
  goal_level: 'EASY',
  goal_weight_delta: 0,
  goal_min_weekly_calorie_increase: 45,
  previous_diet_calories: 2000,
  height: '',
  height_feet: '',
  height_inch: '',
  // highLow: '',
  maintenance_calories: '',
  use_metric_units: '0',
  weight: '',
  diet_restrictions: new Set(),
  target_weight: '',
}

export default (state=registerDefault, action) => {
  switch(action.type) {
    case 'UPDATE_RESET_PROFILE_FIELD':
      state = {...state,
        ...action.payload
      }
      break;
    default: break; // Do nothing
  }
  return state;
};
